import { Injectable } from '@angular/core';
import { Subject } from "rxjs";
import { ConfirmationService, MessageService } from "primeng/api";
import { NgForm, FormGroup } from '@angular/forms';
import { HttpResponseMessage } from './models/models';
import * as JP from "jsonpath";

@Injectable({
  providedIn: 'root'
})
export class UtilityService {
	subject: Subject<boolean>;
	constructor(private ms: MessageService, private cs: ConfirmationService) { }


	Show(msg:string, type:string,header?:string){         
        this.ms.add({detail:msg,severity:type,summary:header});
    }
    Confirmation(message: string,headerTitle?:string) {
        this.subject = new Subject<boolean>();
        this.cs.confirm({
        message: message,
            header: headerTitle,
            closeOnEscape: false,
            accept: () => {
                this.subject.next(true);              
                this.subject.complete();
            },
            reject: () => {
                this.subject.next(false);
                this.subject.complete();
            }
        });
        return this.subject;
    }
    Validate(){
        return true;
    }   

     ClearGroupsDirty(fgs:FormGroup[]) {
        fgs.forEach((fg: FormGroup) => {
            fg.reset(fg.value);
        });
     }

      ClearFormDirty(form: NgForm) {
        if(form != undefined){
            form.reset(form.value);
        }
     }

    reset_form(popupinstance){
        popupinstance.reset();
    }
    toggleGridRowForEdit( table, id, value) {
    table.editingRowKeys = { [id]: value }
     }

     getValueByID(datasource, textField, valueField, value) {
      var found = false;
      var text = "";
      for (var item of datasource) {
        if (item[valueField] == value) {
          found = true;
          text = item[textField];
          break;
        }
      }
      if (found) {
        return text;
      }
    }

    IsFormDirty(scope: any, name: string): boolean 
    {
        return scope[name]?.dirty;
    }
    FormGroupsDirty(fgs: FormGroup[]): boolean {
    let dirty = false;
    fgs.forEach((fg: FormGroup) => {
      if (fg.dirty)
        dirty = true;
    });
    return dirty;
  }
    DownloadFile(httpResponse: HttpResponseMessage) {
    let fileName: string = 'download'
    const downloadLink = document.createElement('a')
    downloadLink.href = URL.createObjectURL(
      new Blob([httpResponse.Content], {
        type: httpResponse.ContentType,
      }),
    )

    const contentDisposition = httpResponse.Headers.headers.get(
      'content-disposition',
    )
    if (contentDisposition !== undefined) {
      fileName = contentDisposition[0]
        .split(';')[1]
        .split('filename')[1]
        .split('=')[1]
        .trim()
    }
    downloadLink.download = fileName
    downloadLink.click()
  }

  EnableFormGroups(fgs: FormGroup[]) {
    fgs.forEach((fg: FormGroup) => {
      fg.enable();
    });
  }

  DisableFormGroups(fgs: FormGroup[]) {
    fgs.forEach((fg: FormGroup) => {
      fg.disable();
    });
  }
  DisableForm(form: NgForm) {
    if(form != undefined){
      form.control.disable()
    }
  }

 EnableForm(form: NgForm) {
  if(form != undefined){
    form.control.enable()
  }
 }

 SearchFromJson(jobject: any, path: string, isArray:boolean=false) {
 if(isArray)
    return JP.query(jobject, path)?.[0];
    else
    return JP.query(jobject, path);
  }

   

  Find<T>(arr: T[], expression: (item: T) => boolean): any {
    if (arr == undefined || arr.length == 0) return undefined;
    return arr.find(expression);
  }

  FindAll<T>(arr: T[], expression: (item: T) => boolean): T[] {
    if (arr == undefined || arr.length == 0) return undefined;
    return arr.filter(expression);
  }

  Max<T>(arr: T[], condition: any, expression: any): any {
    if (arr == undefined || arr.length == 0) return undefined;
    return arr
      .filter(condition)
      .map(expression)
      .reduce((a, b) => (a < b ? a : b));
  }

  Min<T>(arr: T[], condition: any, expression: any): any {
    if (arr == undefined || arr.length == 0) return undefined;
    return arr
      .filter(condition)
      .map(expression)
      .reduce((a, b) => (a > b ? a : b));
  }

  Sort<T>(arr: T[], condition: any, expression: any): any {
    if (arr == undefined || arr.length == 0) return undefined;
    return arr.filter(condition).sort(expression);
  }

  Sum<T>(arr: T[], condition: any, expression: any): any {
    if (arr == undefined || arr.length == 0) return undefined;
    return arr
      .filter(condition)
      .map(expression)
      .reduce((a: any, b: any) => a + b);
  }

  Average<T>(arr: T[], condition: any, expression: any): any {
    if (arr == undefined || arr.length == 0) return undefined;
    return this.Sum(arr, condition, expression) / arr.length;
  }

  Count<T>(arr: T[], condition: any): any {
    if (arr == undefined || arr.length == 0) return undefined;
    return arr.filter(condition).length;
  }
  scrollToElement(elementId:string,scrollBehavior:any,verticalAllignment:any){
    if(elementId == null || elementId == "") return;
    document.getElementById(elementId).scrollIntoView({
      behavior: scrollBehavior,
      block: verticalAllignment
    });
  }
  getCalendarResponsiveOptions():any{
    return [{
      'breakpoint': '1024px',
      'numMonths': 3,
    },
    {
      'breakpoint': '768px',
      'numMonths': 2,
    },
    {
      'breakpoint': '560px',
      'numMonths': 1,
    }]
  }
  hasNullObjectValue(obj: any,field:string): boolean {
    if(obj){
        if(obj[field] === null){
            return true;
        }
    }
    else{
      return false;
    }
  }

}
